/* eslint-disable global-require, class-methods-use-this */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  getFilterValuesBasedOnElementId,
  postActiveFilters,
  getAllUnmatchedCases,
} from 'Apis/caseDataAPI.js';
import {
  exportAmexQueueData,
  exportImageQueueData,
  exportMerchantQueueData,
  exportUnmatchedQueue,
  exportWexQueueData,
  exportActiveStageQueue
} from 'Apis/exportApi.js';
import {
  postBookMarkCase,
  undoBookMarkCase,
  getExceptionCasesCount,
  getMerchantMatchedFailCasesCount,
  getDefaultQueueCasesCount,
  getMerchantImageAllRegionCount,
  getSchemeExceptionCasesCount,
  getAssignedCasesCount,
  getAmexOp1CasesCount,
  getMexicoQueueCount,
  getWexCasesCount
} from 'Apis/queueManagerApi.js';
import './QueueLanding.scss';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import { archiveNonDimsImage } from 'Apis/imageMatcherApi';
import EmptyState from 'Components/EmptyState/EmptyState';
import GDTable from 'Components/GDTable';
import { getMetaData, getTranslations, getValidations, getBookMarkIconValues, getDeleteIconValues, getFolderIconValues, getImageIconValues, getOpenInNewTabValues } from './configStructure';
import GDDetailView from 'Components/GDDetailView';
import ResponseBanner from 'Components/cards/ResponseBanner';
import FilterPane from 'Components/FilterPane';
import classnames from 'classnames';
import { addManualTransactionNotificationBanner, closeNotificationBanner } from 'Actions/notificationAction';
import { fetchFilterElements, fetchSearchTypeIdBasedOnSearchName } from 'Actions/searchFilterAction';
import PropTypes from 'prop-types';
import GDActiveFiltersDropdown from 'Components/GDActiveFiltersDropdown/GDActiveFiltersDropdown';
import LinkInlineButton from 'Components/Button/LinkInlineButton';
import 'Components/GDReportRunner/GDReportRunner.scss';
import { fetchDataColumns } from 'Actions/dataColumnsAction';
import {
  mapActiveFilters,
  mapSavedFilters,
} from 'Utils/reports/reportFilterUtils';
import GDNewFilterDropdown from 'Components/GDNewFilterDropdown';
import GDSavedFiltersDropdown from 'Components/GDSavedFiltersDropdown';
import OptionBoxPopup from 'Components/OptionBoxPopup';
import StarIcon from 'Components/icons/StarIcon';
import QueuesDropdown from 'Components/QueuesDropdown/QueuesDropdown.jsx';
import { fetchSavedFilterElements, saveActiveFilters, deleteSavedFilters } from 'Actions/savedFilterAction';
import { setDrawerOpenFlag } from 'Actions/drawerAction';
import { setAccountNumberId } from 'Actions/accountNumberAction';
import moment from 'moment';
import { getToken } from 'Apis/tokenizeFilterElement';
import { getUrlSearchParamValue } from 'Utils/urlUtils';
import { sort_by } from 'Utils/functionalUtils.js';
import { gotoNewTabCaseLandingPage } from 'Utils/newTabUtils.jsx';
import { setCaseStageId, setOp1CaseDetail } from 'Utils/localStorageUtils.js';
import { downloadFile } from 'Utils/exportFunctionality.js';
import { deleteNonDimsCase } from 'Apis/dimsCaseValidatorApi.js';
import { getAcquirerAccessList } from 'Utils/permissionsUtils';
import { VITE_isIE, VITE_QUEUE_MGMT_QUEUES, VITE_AVAILABLE_QUEUES, VITE_IMAGE_MATCH_QUEUES } from 'Constants/appEnvConstants';
import { flushSync } from 'react-dom';
import { QUEUE_IDS } from 'Constants/queueLandingConstants';
import { isObject } from 'Utils/lodashUtils';
import ImagePortal from 'Containers/ImagePortal';

const summaryData = [];
export class QueueLanding extends Component {
  constructor(props) {
    super(props);
    this.state = {
      caseData: [],
      isLoading: true,
      totalRecords: 0,
      totalPages: 0,
      recordsShown: 0,
      currentPage: 0,
      filterText: '',
      isNextPage: false,
      exporting: false,
      filterExportIsVisible: false,
      selectedKeyIndex: 0,
      structureMetaData: {},
      drawerOpen: false,
      selectionPanelOpen: false,
      prePopulatedFilterValues: [],
      scrollPos: 0,
      openBanner: false,
      targetDone: false,
      createdCaseNumber: '',
      dropdownToggled: {
        active: false,
        inactive: false,
      },
      filters: [],
      activeFilters: [],
      dateFormat: 'MM/DD/YYYY',
      isVisible: false,
      finalFilterElements: [],
      multiSelectLength: 0,
      apiMultiSelectCount: 0,
      isRequiredFilter: false,
      savedFilters: [],
      saveFilterToggled: false,
      gridSortArray: [],
      filterName: '',
      currentSearchTerm: '',
      noSavedFilters: false,
      queueList: [],
      appliedFilterParams: [],
      isLoadingComplete: true,
      saveFilterFail: false,
      dataColumns: [],
      queueId: 0,
      bookMarkedRows: [],
      isBookMarked: false,
      isCurrentlySavedFilters: false,
      emptyStateHeading: 'Unauthorized',
      emptyStateDescription: 'You are not authorized to view this content.',
      isFirstCall: true,
      setSize: false,
    };
    this.attachBindings();
  };

  attachBindings() {
    this.getAllCasesData = this.getAllCasesData.bind(this);
    this.rowActionClick = this.rowActionClick.bind(this);
    this.toggleDrawer = this.toggleDrawer.bind(this);
    this.goToNextRecord = this.goToNextRecord.bind(this);
    this.prepopulateFilterValues = this.prepopulateFilterValues.bind(this);
    this.gotoCaseSelectionPage = this.gotoCaseSelectionPage.bind(this);
    this.renderResponseBanner = this.renderResponseBanner.bind(this);
    this.closeBanner = this.closeBanner.bind(this);
    this.copyToClipBoard = this.copyToClipBoard.bind(this);
    this.closeFilterPane = this.closeFilterPane.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
    this.toggleFilterPane = this.toggleFilterPane.bind(this);
    this.getAllMultiSelectData = this.getAllMultiSelectData.bind(this);
    this.applySavedFilterSet = this.applySavedFilterSet.bind(this);
    this.deactivateFilter = this.deactivateFilter.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.toggleSavedFilter = this.toggleSavedFilter.bind(this);
    this.onChange = this.onChange.bind(this);
    this.saveFilterName = this.saveFilterName.bind(this);
    this.updateSearchField = this.updateSearchField.bind(this);
    this.removeSavedFilter = this.removeSavedFilter.bind(this);
    this.setSavedFilterAsActive = this.setSavedFilterAsActive.bind(this);
    this.clearAllFilters = this.clearAllFilters.bind(this);
    this.resetScrollPos = this.resetScrollPos.bind(this);
    this.selectQueue = this.selectQueue.bind(this);
    this.getQueueList = this.getQueueList.bind(this);
    this.closeSaveFilterFailBanner = this.closeSaveFilterFailBanner.bind(this);
    this.saveCurrentlyVisibleColumns = this.saveCurrentlyVisibleColumns.bind(this);
    this.addIconsToGDTableHeadersList = this.addIconsToGDTableHeadersList.bind(this);
    this.postActiveFilters = this.postActiveFilters.bind(this);
    this.closeNotification = this.closeNotification.bind(this);
    this.getTokenFromCardNumber = this.getTokenFromCardNumber.bind(this);
    this.onBookMarked = this.onBookMarked.bind(this);
    this.checkSize = this.checkSize.bind(this);
    this.setPrimaryButtonAction = this.setPrimaryButtonAction.bind(this);
    this.reloadQueueLandingPage = this.reloadQueueLandingPage.bind(this);
    this.deleteCase = this.deleteCase.bind(this);
    this.archiveUnmatchedSchemeImage = this.archiveUnmatchedSchemeImage.bind(this);
    this.archiveUnmatchedSchemeImageApiCall = this.archiveUnmatchedSchemeImageApiCall.bind(this);
    this.getAllQueueOnAcquirerBasis = this.getAllQueueOnAcquirerBasis.bind(this);
    this.getExceptionQueueCount = this.getExceptionQueueCount.bind(this);
    this.getMerchantMatchedFailCasesCount = this.getMerchantMatchedFailCasesCount.bind(this);
    this.getDefaultQueueCasesCount = this.getDefaultQueueCasesCount.bind(this);
    this.getMerchantImageAllRegionCount = this.getMerchantImageAllRegionCount.bind(this);
    this.getSchemeExceptionCasesCount = this.getSchemeExceptionCasesCount.bind(this);
    this.getAssignedCasesCount = this.getAssignedCasesCount.bind(this);
    this.getAmexOp1CasesCount = this.getAmexOp1CasesCount.bind(this);
    this.getWexCasesCount = this.getWexCasesCount.bind(this);
    this.closeFilterBanner = this.closeFilterBanner.bind(this);
    this.getMexicoQueueCount = this.getMexicoQueueCount.bind(this);
    this.getDataForAllUnmatchedCases = this.getDataForAllUnmatchedCases.bind(this);
    this.refreshTimeFeed = this.refreshTimeFeed.bind(this);
  };

  componentWillMount() {
    window.scrollTo(0, 0);
  };

  componentDidMount() {
    document.body.scrollTop = 0;
    const searchFilterName = getMetaData(this.props.queueId)?.searchFilterName;
    searchFilterName && this.props.fetchSearchTypeIdBasedOnSearchName(searchFilterName);
    this.props.fetchDataColumns(getMetaData(this.props.queueId).pageId);
    const regionCode = getUrlSearchParamValue(this.props.location.search, 'regionCode');
    let acquirerAccessList=getAcquirerAccessList();
    this.getAllQueueOnAcquirerBasis(acquirerAccessList);
    this.setState({
      queueId: this.props.queueId,
      hideBaseQueueDropdown: getUrlSearchParamValue(this.props.location.search, 'hideBaseQueueDropdown') == "true" ? true : false,
      regionCode: regionCode,
      gridSortArray: getMetaData(this.props.queueId).defaultSort,
    });
    document.addEventListener('mousedown', this.handleOutsideClick);
  };

  deleteCase(caseNumber) {
    return deleteNonDimsCase(caseNumber)
      .then((apiResponse) => {
        const statusCode = apiResponse.status.statusCode;
        if (statusCode === 2000) {
          this.setState({ isLoading: true })
          this.props.setNotification([{
            title: 'Case Deleted Successfully',
            titleStyle: "color: 'light-green'",
            description: 'The Case Has Been Deleted Successfully',
            descriptionStyle: "color: 'grey'",
            type: 'success',
            cancel: true,
            cancelButtonText: 'DISMISS',
            primaryButtonText: 'OK',
            primaryButtonAction: () => this.reloadPage(),
            valueStyle: "color: 'black'",
            refreshData: "true",
            closeNotification: () => this.reloadPage(),
          }]);
        }
      })
      .catch((error) => {
        this.props.setNotification([{
          title: 'Error Occurred',
          description: 'Error Occurred While Deleting The Case',
          type: 'danger',
          cancelButtonText: 'DISMISS',
          primaryButtonText: 'OKAY, DO SOMETHING TO FIX IT',
          primaryButtonAction: this.props.closeNotification,
          closeNotification: this.props.closeNotification,
          refreshData: "false",
        }]);
      });
  };

  archiveUnmatchedSchemeImageApiCall(id) {
    this.setState({ isLoading: false });
    return archiveNonDimsImage(id)
      .then((apiResponse) => {
        const statusCode = apiResponse.status.statusCode;
        if (statusCode === 2000) {
          this.props.setNotification([{
            title: 'SDM Image Archived Successfully',
            titleStyle: "color: 'light-green'",
            description: 'The SDM Image Has Been Archived Successfully',
            descriptionStyle: "color: 'grey'",
            type: 'success',
            cancel: true,
            cancelButtonText: 'DISMISS',
            primaryButtonText: 'OK',
            primaryButtonAction: this.reloadQueueLandingPage,
            valueStyle: "color: 'black'",
          }]);
        }
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        this.props.setNotification([{
          title: 'Error Occurred',
          description: 'Error Occurred While Archiving Image',
          type: 'danger',
          cancelButtonText: 'DISMISS',
          primaryButtonText: 'OKAY, DO SOMETHING TO FIX IT',
          primaryButtonAction: this.props.closeNotification,
        }]);
      });

  };

  archiveUnmatchedSchemeImage(id) {
    this.setState({ isLoading: true });
    this.props.setNotification([{
      title: 'Archive Image',
      description: 'Do you want to archive this image?',
      descriptionStyle: "color: 'grey'",
      type: 'warning',
      cancel: true,
      isSecondaryButtonActive: true,
      isSecondaryButton: true,
      primaryButtonText: 'YES',
      cancelButtonText: 'NO',
      valueStyle: "color: 'black'",
      closeNotification: this.closeBanner,
      primaryButtonAction: () => this.archiveUnmatchedSchemeImageApiCall(id),
    }]);
  };

  componentWillReceiveProps(nextProps) {
    if ((this.props.searchTypeId !== nextProps.searchTypeId) || (this.state.isVisible && this.props.searchTypeId === nextProps.searchTypeId &&
      this.props.filters.length === 0 && nextProps.filters.length === 0)) {
      this.props.fetchFilterElements(nextProps.searchTypeId);
      this.props.fetchSavedFilterElements(nextProps.searchTypeId);
    }
    if (this.props.queueId != nextProps.queueId) {
      let acquirerAccessList=getAcquirerAccessList();
        this.getAllQueueOnAcquirerBasis(acquirerAccessList);
    }

    if (this.props.filters.length !== nextProps.filters.length) {
      const mergeFilter = this.mergeElementIdsForRangeElements(nextProps.filters);
      const filtersWithValidations = mergeFilter.map((filter) => {
        return {
          ...filter,
          validations: getValidations(filter.elementTypeName) === undefined ? [] : getValidations(filter.elementTypeName).validations,
        };
      });

      let multiSelectFiltersIds = [];
      filtersWithValidations.forEach((filter) => {

        if (filter.elementTypeName === 'MULTISELECT') {
          multiSelectFiltersIds = multiSelectFiltersIds.concat(filter.elementId);
        }
      });
      multiSelectFiltersIds.forEach((multiSelectFiltersId) => {
        this.getAllMultiSelectData(multiSelectFiltersId, multiSelectFiltersIds.length);
      });

      this.setState({
        formattedFilters: filtersWithValidations,
        multiSelectFiltersIds,
      });
    }
    if (this.props.savedFilters && this.state.savedFilters.length == 0 && this.state.formattedFilters == undefined && this.props.savedFilters!=nextProps.savedFilters) {
      this.props.fetchFilterElements(nextProps.searchTypeId);
      this.props.fetchSavedFilterElements(nextProps.searchTypeId);
    }

    if (this.props.savedFilters && nextProps.savedFilters && JSON.stringify(this.props.savedFilters)!=JSON.stringify(nextProps.savedFilters)) {
      this.setState({
        savedFilters: this.mergeSavedElementIdsForRangeElements(nextProps.savedFilters),
        noSavedFilters: false,
      });
    } else if (nextProps.savedFilters.length == 0) {
      this.setState({
        noSavedFilters: true,
      });
    }
    
    if ((this.props.location !== nextProps.location && this.props?.dataColumns?.length !== nextProps.dataColumns?.length) || this.props?.dataColumns?.length !== nextProps.dataColumns?.length || this.props.pageId !== nextProps.pageId) {
      this.setState({
        dataColumns: this.addIconsToGDTableHeadersList(nextProps.dataColumns),
        gridSortArray: Object.assign([], getMetaData(nextProps.queueId).defaultSort),
      }, () => {
        if (!this.state.isCurrentlySavedFilters)
          this.getAllCasesData(nextProps.queueId, 0, 25, this.state.gridSortArray);
      });
    }

    if (this.props.queueId !== nextProps.queueId) {
      this.setState({
        queueId: nextProps.queueId,
      });
    }

    const regionCode = getUrlSearchParamValue(nextProps.location.search, 'regionCode');
    if (regionCode !== this.state.regionCode) {
      this.setState({
        regionCode: regionCode
      });
    }
  };

  componentWillUpdate(nextProps, nextState) {
    if (nextState.caseData && nextState.caseData.length > 0 && (this.state.caseData.length !== nextState.caseData.length || this.state.bookMarkedRows.length == 0)) {
      nextState.caseData.map((rowVal) => {
        if (rowVal.bookmarkedBy) {
          this.setState((prevState) => ({
            bookMarkedRows: prevState.bookMarkedRows.concat(rowVal.caseStageId),
          }));
        }
      })
    }
  };

  componentDidUpdate() {
    if (this.state.finalFilterElements.length == 0 && this.state.apiMultiSelectCount > 0 && this.state.multiSelectLength === this.state.apiMultiSelectCount) {
      const finalFilterElements = this.state.formattedFilters.map((filterElement) => {
        if (this.state.multiSelectFiltersIds.indexOf(filterElement.elementId) === -1) {
          return filterElement;
        } else {
          return {
            filterValues: this.state[filterElement.elementId],
            ...filterElement,
          };
        }
      });
      this.setState({
        finalFilterElements,
        isLoading: false,
        savedFilters: this.mergeSavedElementIdsForRangeElements(this.props.savedFilters),
        noSavedFilters: false,
      }); 
    }
  };

  componentWillUnmount() {
    this.props.fetchFilterElements(-1);
    document.removeEventListener('mousedown', this.handleOutsideClick);
  };

  mergeElementIdsForRangeElements(filters) {
    let targetObjects = [];
    filters.forEach((filterElement1) => {
      let toElementClone = {};

      if (filterElement1.elementCategoryName === 'FROM') {
        const toElement = filters.find((filterElement2) => {
          return filterElement2.elementSequenceNumber === filterElement1.elementSequenceNumber && filterElement2.elementCategoryName === 'TO';
        });

        toElementClone = { ...toElement };
        toElementClone.elementId = `${filterElement1.elementId}-${toElement.elementId}`;
        toElementClone.elementCategoryName = `${filterElement1.elementCategoryName}-${toElement.elementCategoryName}`;
        targetObjects = targetObjects.concat(toElementClone);
      } else if (filterElement1.elementCategoryName !== 'TO') { targetObjects = targetObjects.concat(filterElement1); }
    });
    return targetObjects;
  };

  mergeSavedElementIdsForRangeElements(savedFilters) {
    let finalSavedFilters = [];
    savedFilters.forEach((savedFilter) => {
      let targetObjects = [];
      savedFilter.filterParams.forEach((filterElement1) => {
        const toElementClone = {};
        if (filterElement1.elementCategoryName === 'FROM') {
          const toElement = savedFilter.filterParams.find((filterElement2) => {
            return filterElement2.elementSequenceNumber === filterElement1.elementSequenceNumber && filterElement2.elementCategoryName === 'TO';
          });
          toElementClone.id = toElement !== undefined ? `${filterElement1.elementId}-${toElement.elementId}` : `${filterElement1.elementId}`;
          toElementClone.v1 = `${filterElement1.elementValue}`;
          if (toElement !== undefined && toElement.elementValue !== undefined) { toElementClone.v2 = `${toElement.elementValue}`; }
          targetObjects = targetObjects.concat(toElementClone);
        } else if (filterElement1.elementCategoryName !== 'TO') {
          toElementClone.id = `${filterElement1.elementId}`;
          toElementClone.v1 = filterElement1.elementTypeName !== 'MULTISELECT' ? `${filterElement1.elementValue}` : `${filterElement1.elementValue}`.split(',');
          targetObjects = targetObjects.concat(toElementClone);
        }
      });
      finalSavedFilters = finalSavedFilters.concat({ ...savedFilter, filterParams: targetObjects });
    });
    return finalSavedFilters;
  };

  getAllCasesData(queueId, pageNumber, paginatedRecords, sortArray, lazyLoad, appliedFilters) {
    const regionCode = getUrlSearchParamValue(this.props.location.search, 'regionCode');
    const structureMetaData = getMetaData(queueId);
    this.setState({
      isLoading: true,
    })
    structureMetaData.dataColumns = this.addIconsToGDTableHeadersList(this.state.dataColumns);
    setTimeout(() =>
      this.setState((prevState) => ({
        structureMetaData,
        queueId,
        recordsShown: paginatedRecords,
        gridSortArray:  sortArray,
        caseDataErr: false,
        isLoading: false,
        isPagable: structureMetaData.isPagable,
        lazyLoadPageNumber: pageNumber,
        appliedFilterParams: appliedFilters,
        isCurrentlySavedFilters: false,
        agLoader: false,
        regionCode: regionCode,
      })), 500);
  };

  getQueueList(regionCode, queueId, totalCases) {
    const structureMetaData = getMetaData(queueId);
        const queueListData = totalCases && totalCases.sort(sort_by('queueName', false, function (a) { return a.toUpperCase() }));
        let queueName = '';
        queueName = structureMetaData.name;
        const filteredList = queueListData && queueListData.filter(row => row.queueId == queueId);
        if (filteredList.length > 1) {
          queueName = filteredList.filter(row => row.regionCode == regionCode)[0]?.queueName;
        } else if (filteredList.length == 1) {
          queueName = filteredList[0].queueName;
        }
        return queueName;
  };

  getAllQueueOnAcquirerBasis(acquirerAccessList) {
    this.getExceptionQueueCount(acquirerAccessList);
    this.getMerchantMatchedFailCasesCount(acquirerAccessList);
    this.getSchemeExceptionCasesCount(acquirerAccessList);

    if(acquirerAccessList.includes('GPN'))
      {
      this.getDefaultQueueCasesCount(acquirerAccessList);
      this.getMerchantImageAllRegionCount(acquirerAccessList);
      this.getAssignedCasesCount();
      }
      if(acquirerAccessList.includes('HPY'))
      { 
      this.getWexCasesCount();
      }
      if(acquirerAccessList.includes('GPN') || acquirerAccessList.includes('HPY'))
      { 
      this.getAmexOp1CasesCount();
      }
      if(acquirerAccessList.includes('MXP'))
      { 
      this.getMexicoQueueCount();
      }
  };

  getMexicoQueueCount() {
    getMexicoQueueCount().then((response) => {
     this.setState({
      mexicoCases: response.data,
     });
   }).catch((error) => {
     console.log('error received while fetching data columns based on queue page', error);
   });
  };

  getAssignedCasesCount() {
     getAssignedCasesCount().then((response) => {
      this.setState({
        assignedCases : response.data,
        isLoading: false,
      });
    }).catch((error) => {
      console.log('error received while fetching data columns based on queue page', error);
    });
  };

  getExceptionQueueCount(acquirerAccessList) {
     getExceptionCasesCount(acquirerAccessList).then((response) => {
      this.setState({
        exceptionCases: response.data,
        isLoading: false,
      });
    }).catch((error) => {
      console.log('error received while fetching data columns based on queue page', error);
    });
  };

  getMerchantMatchedFailCasesCount(acquirerAccessList) {
     getMerchantMatchedFailCasesCount(acquirerAccessList).then((response) => {
      this.setState({
        merchMatchCases: response.data,
        isLoading: false,
      });
    }).catch((error) => {
      console.log('error received while fetching data columns based on queue page', error);
    });
  };

  getDefaultQueueCasesCount(acquirerAccessList) {
     getDefaultQueueCasesCount(acquirerAccessList).then((response) => {
      this.setState({
        defaultCases: response.data,
        isLoading: false,
      });
    }).catch((error) => {
      console.log('error received while fetching data columns based on queue page', error);
    });
  };

  getMerchantImageAllRegionCount(acquirerAccessList) {
     getMerchantImageAllRegionCount(acquirerAccessList).then((response) => {
      this.setState({
        merchImageCases: response.data,
        isLoading: false,
      });
    }).catch((error) => {
      console.log('error received while fetching data columns based on queue page', error);
    });
  };

  getSchemeExceptionCasesCount(acquirerAccessList) {
     getSchemeExceptionCasesCount(acquirerAccessList).then((response) => {
      this.setState({
        schemeCases: response.data,
        isLoading: false,
      });
    }).catch((error) => {
      console.log('error received while fetching data columns based on queue page', error);
    });
  };

  getAmexOp1CasesCount() {
    getAmexOp1CasesCount().then((response) => {
     this.setState({
       amexCases: response.data,
       isLoading: false,
     });
   }).catch((error) => {
     console.log('error received while fetching data columns based on queue page', error);
   });
  };

  getWexCasesCount() {
  getWexCasesCount().then((response) => {
   this.setState({
     wexCases: response.data,
     isLoading: false,
   });
 }).catch((error) => {
   console.log('error received while fetching data columns based on queue page', error);
 });
  };

  getAllMultiSelectData(multiSelectFiltersId, multiSelectLength) {
    getFilterValuesBasedOnElementId(multiSelectFiltersId)
      .then((response) => {
        const formattedData = this.getFormattedResponse(response, multiSelectFiltersId);
        this.setState((prevState) => ({
          multiSelectLength,
          [multiSelectFiltersId]: formattedData,
          apiMultiSelectCount: prevState.apiMultiSelectCount + 1,
          isLoading: false
        }));
      })
      .catch((error) => {
        this.setState({
          caseDataErr: true,
          isLoading: false
        })
        console.log('Error Occured while fetching filter values based on element id', error);
      });
  };

  getFormattedResponse(response, filter) {
    let filterValues = [];
    response.data.forEach((filterValue,index) => {
      if (filter === 'case_type' || filter === 'trans_case_stage') {
        if(this.state.queueId  ===  '70' ) {
          filterValues = filterValues.concat({
            id: filterValue.stageId,
            value: filterValue.stageName,
            text: filterValue.stageName,
          });
        }
        else {
          let newFilterValue = response.data.filter(Item => {
            return Item.stageId !=27});

          if(newFilterValue.length - 1>=index ){
            filterValues = filterValues.concat({
              id: newFilterValue[index].stageId,
              value: newFilterValue[index].stageName,
              text: newFilterValue[index].stageName,
            });
            
          }
          }
      }

      if (filter === 'disposition') {
        filterValues = filterValues.concat({
          value: filterValue.dispositionCode,
          text: filterValue.dispositionDescription,
        });
      }if (filter === 'action_code') {
        filterValues = filterValues.concat({
          value: filterValue.actionCode,
          text: filterValue.actionDescription,
        })
      }
      
      if (filter === 'case_status') {
        filterValues = filterValues.concat({
          id: filterValue.statusId,
          value: filterValue.statusName,
          text: filterValue.statusName,
        });
      }
    });
    return filterValues;
  };

  resetScrollPos() {
    this.setState({
      scrollPos: 0,
    });
  };

  loadDataOnScroll = () => {
    if (!(this.state.totalRecords - this.state.caseData.length <= 0)) {
      this.getAllCasesData(this.state.queueId, this.state.lazyLoadPageNumber + 1, this.state.recordsShown, this.state.gridSortArray, true, this.state.appliedFilterParams);
    } else {
      this.setState({
        isLoadingComplete: false,
      });
    }
  };

  getFormattedData(queueId, apiResponse) {
    let formattedData;
    switch (queueId) {
      case '6':

        formattedData = apiResponse.data.content.map((row) => {
          return Object.assign(row.caseStageDetail, row.unmatchedCaseDetailModel, row.transactionDetail);
        });
        break;
      case '8':
        formattedData = apiResponse.data.content.map((row) => {
          return Object.assign(row.caseDetail, row.caseStageDetail, row.transactionDetail);
        });
        break;
      case '9':
      case '15':
      case '36':
      case '71':
      case '80':
      case '81':
        formattedData = apiResponse.data.content;
        break;
    }
    return formattedData;
  };

  saveCurrentlyVisibleColumns(columns) {
    this.setState({
      dataColumns: columns,
    });
    const activeDataColumns = [];
    columns.forEach((column) => {
      if (column.displayType !== 'ICON') {
        const activeColumn = {
          columnId: column.columnId,
          displayOrder: column.displayOrder,
        };
        activeDataColumns.push(activeColumn);
      }
    });
    this.postActiveFilters(activeDataColumns);
  };

  postActiveFilters(columns) {
    return postActiveFilters(getMetaData(this.state.queueId).pageId, columns)
      .then((apiResponse) => {
        this.props.fetchDataColumns(getMetaData(this.props.queueId).pageId);
        this.setState({
          caseDataErr: false,
          isLoading: false,
          isCurrentlySavedFilters: true,
        });
      })
      .catch((error) => {
        this.setState({ caseDataErr: true, isLoading: false });
        console.log('Error Occured while saving active data columns', error);
      });
  };

  addIconsToGDTableHeadersList(columns) {
    const pageId = getMetaData(this.state.queueId).pageId;
    const iconsColumns = columns.find((column) => column.displayType == 'ICON');
    if (!iconsColumns) {
      if (pageId != 'unmatch_scheme_image' && pageId != 'unmatch_merch_image' && pageId != 'wex_queue') {
        this.props.user && this.props.user.parsedPermissions && this.props.user.parsedPermissions.case && this.props.user.parsedPermissions.case.canBookmark && columns.unshift(getBookMarkIconValues());
        columns.push(getOpenInNewTabValues());
      }
      if(pageId==='wex_queue'){
        columns.push(getOpenInNewTabValues());
      }
      if (pageId === 'tran_unmatched' || pageId === 'merch_matched_fail' || pageId === 'amex_queue' || pageId === 'wex_queue'|| pageId === 'active_stage') {
        columns.push(getFolderIconValues());
      }
      if (pageId === 'unmatch_scheme_image' || pageId === 'unmatch_merch_image') {
        columns.push(getImageIconValues());
        columns.push(getDeleteIconValues());
      }
    }
    return columns;
  };

  setRecordCount = (recordCount, totalRecords) => {
    this.setState({
      recordsShown: recordCount,
      totalRecords: totalRecords,
    })
  };

  handleSort = (key) => {
    const newSortArray = this.state.gridSortArray.some(ele => ele.key === key)
      ? this.state.gridSortArray
          .filter(element => element.key === key)
          ?.map(element => ({ key, order: (element.order + 1) % 2 }))
      : [{ key, order: 1 }];
    this.setState({
      currentPage: 1,
      agLoader: true,
      isLoading: true,
      gridSortArray: newSortArray,
    });
    this.getAllCasesData(this.state.queueId, 0, this.state.recordsShown, newSortArray, false, this.state.appliedFilterParams);
  };

  // eslint-disable-next-line no-undef
  setDataRange = () => {
    const offset = Math.ceil((this.state.currentPage - 1) * this.state.recordsShown);
    this.setState({
      caseData: this.state.caseData.slice(offset, offset + this.state.recordsShown),
    });
  };

  // eslint-disable-next-line no-undef
  pageHandler = (newPage, newPerPage) => {
    const pageSize = newPerPage === undefined ? this.state.recordsShown : newPerPage;
    if (newPage) {
      this.getAllCasesData(this.state.queueId, newPage - 1, pageSize, this.state.gridSortArray);
    }
  };

  // eslint-disable-next-line no-undef
  onSearchChange = (filterText) => {
    this.setState({ filterText });
  };

  // eslint-disable-next-line no-undef
  onRowClick = (event, sequenceKey) => {
    if ((!event.target.id &&
      !event.target.classList.contains('gd-row-actions') &&
      !event.target.classList.contains('dropdown-menu-trigger')) ||
      event.target.parentNode.classList.contains('primary')) {
      alert(`Row #${sequenceKey} clicked.`); // eslint-disable-line
    }
  };

  // eslint-disable-next-line no-undef
  exportAction = (fileObject) => {
    this.toggleFileExport();
    let isAllColumns = fileObject.exportType.value === 'all-columns' ? true : false;
    let fileType = fileObject.fileType.value;
    let fileName = fileObject.fileName;
    this.state.totalRecords > 25000 ?
      this.setState({
        setSize: true,
      })
      :
      this.exportFile(fileName, fileType, isAllColumns);
  };

  exportFile(fileName, fileType, isAllColumns) {
    const sortObj = this.state.gridSortArray.map(obj => {
      return {
        fieldId: obj.key,
        orderByProperty: (obj.order) ? 'ASC' : 'DESC',
      }
    })
    let sortKey = [];
    let sortOrder = [];
    let acquirerList=getAcquirerAccessList();
    sortObj.forEach((element) => {
      sortKey.push(element.fieldId);
      sortOrder.push(element.orderByProperty);
    });
    if (this.props.queueId == QUEUE_IDS.AMEX_QUEUE_ID) {
      let amexQueueExportData = {
        fileType: fileType,
        isAllColumns: isAllColumns,
        pageId: this.props.pageId,
        unmatchedDocumentInput: {
          orderByProperties: sortKey,
          pageNumber: 0,
          propertyDirections: sortOrder,
          size: this.state.totalRecords,
          regionCode: this.state.regionCode,
          acquirerList: acquirerList,
          isFilterAvailable:!(this.state.appliedFilterParams=== undefined || this.state.appliedFilterParams.length === 0),
          searchFilterInputElements:this.state.appliedFilterParams,
        }
      }
      this.setState({ exporting: true });
      exportAmexQueueData(amexQueueExportData).then((response) => {
        downloadFile(fileName, fileType, response);
        this.setState({ exporting: false });
      })
        .catch((error) => {
          this.setState({ exporting: false });
          console.log('Error Occured while exporting the case', error);
        });
    }
    else if (this.props.queueId == QUEUE_IDS.WEX_QUEUE_ID) {
      let wexQueueExportData = {
        fileType: fileType,
        isAllColumns: isAllColumns,
        pageId: this.props.pageId,
        unmatchedDocumentInput: {
          orderByProperties: sortKey,
          pageNumber: 0,
          propertyDirections: sortOrder,
          size: this.state.totalRecords,
          regionCode: this.state.regionCode,
        }
      }
      this.setState({ exporting: true });
      exportWexQueueData(wexQueueExportData).then((response) => {
        downloadFile(fileName, fileType, response);
        this.setState({ exporting: false });
      })
        .catch((error) => {
          this.setState({ exporting: false });
          console.log('Error Occured while exporting the case', error);
        });
    }
    else if (this.props.queueId == QUEUE_IDS.UNMATCHED_SCHEME_IMAGE || this.props.queueId == QUEUE_IDS.UNMATCHED_MERCHANT_IMAGE) {
      let imageQueueExportData = {
        fileType: fileType,
        isAllColumns: isAllColumns,
        pageId: this.props.pageId,
        unmatchedDocumentInput: {
          orderByProperties: sortKey,
          pageNumber: 0,
          propertyDirections: sortOrder,
          size: this.state.totalRecords,
          regionCode: this.state.regionCode,
          queueId: this.props.queueId,
          acquirerList: acquirerList,
        }
      }
      this.setState({ exporting: true });
      exportImageQueueData(imageQueueExportData).then((response) => {
        downloadFile(fileName, fileType, response);
        this.setState({ exporting: false });
      })
        .catch((error) => {
          this.setState({ exporting: false });
          console.log('Error Occured while exporting the case', error);
        });
    }
    else if (this.props.queueId == QUEUE_IDS.MERCHANT_UNMATCH_QUEUE_ID) {
      let queueExportData = {
        fileType: fileType,
        isAllColumns: isAllColumns,
        pageId: this.props.pageId,
        unmatchedInput: {
          sortingElement: sortObj,
          size: this.state.totalRecords,
          queueId: this.state.queueId,
          acquirerList: acquirerList,
        }
      }
      this.setState({ exporting: true });
      exportMerchantQueueData(queueExportData).then((response) => {
        console.log(fileName, fileType, response);
        downloadFile(fileName, fileType, response);
        this.setState({ exporting: false });
      })
        .catch((error) => {
          this.setState({ exporting: false });
          console.log('Error Occured while exporting the case', error);
        });
    }
    else if (this.props.queueId == QUEUE_IDS.ACTIVE_STAGE) {
      let queueExportData = {
        fileType: fileType,
        isAllColumns: isAllColumns,
        pageId: this.props.pageId,
        isFilterAvailable:!(this.state.appliedFilterParams=== undefined || this.state.appliedFilterParams.length === 0),
        searchFilterInputElements:this.state.appliedFilterParams,
        inputActiveStageCasesQueues: {
          sortingElement: sortObj,
          size: this.state.totalRecords,
          acquirerList: acquirerList,
          regionCode: this.state.regionCode,
        }
      }
      this.setState({ exporting: true });
      exportActiveStageQueue(queueExportData).then((response) => {
        console.log(fileName, fileType, response);
        downloadFile(fileName, fileType, response);
        this.setState({ exporting: false });
      })
        .catch((error) => {
          this.setState({ exporting: false });
          console.log('Error Occured while exporting the case', error);
        });
    }
    else {     
      let queueExportData = {
        fileType: fileType,
        isAllColumns: isAllColumns,
        pageId: this.props.pageId,
        isFilterAvailable:!(this.state.appliedFilterParams=== undefined || this.state.appliedFilterParams.length === 0),
        searchFilterInputElements:this.state.appliedFilterParams,
        unmatchedInput: {
          sortingElement: sortObj,
          size: this.state.totalRecords,
          acquirerList: acquirerList,
        }
      }
      this.setState({ exporting: true });
      exportUnmatchedQueue(queueExportData).then((response) => {
        downloadFile(fileName, fileType, response);
        this.setState({ exporting: false });
      })
        .catch((error) => {
          this.setState({ exporting: false });
          console.log('Error Occured while exporting the case', error);
        });
    }
  };

  checkSize() {
    this.props.setNotification([{
      title: `Error Occured`,
      descriptionStyle: "color: 'grey'",
      description: 'Your export request has exceeded the limitation of 25,000 rows.  Please apply additional filters to reduce of number rows.',
      type: 'danger',
      noActions: true,
      cancelOnly: true,
      closeNotification: () => this.props.closeNotification(),
    }]);
    this.setState({
      setSize: false
    })
  };

  rowActionClick(selectedKeyIndex, key) {
    switch (key) {
      case 'DETAIL_DRAWER':

        this.setState({
          drawerOpen: true,
          selectedKeyIndex,
        });
        this.props.setDrawerOpenFlag(true);
        break;
      case 'OPEN_CASE':
        this.setState({
          selectionPanelOpen: true,
          selectedKeyIndex,
        });
        this.prepopulateFilterValues(selectedKeyIndex);
        break;
      case 'CASE_LANDING':
        this.setState({
          selectedKeyIndex,
        });
        this.gotoCaseLandingPage(selectedKeyIndex);
        break;
      case 'OPEN_CASE_IN_TAB':
        setCaseStageId(this.state.caseData[selectedKeyIndex].caseStageId);
        setOp1CaseDetail(JSON.stringify(this.state.caseData[selectedKeyIndex]));
        let caseNumberUrl = this.state.caseData[selectedKeyIndex].caseNumber ? +this.state.caseData[selectedKeyIndex].caseNumber : this.state.caseData[selectedKeyIndex].caseStageId ? 'casestage/' + this.state.caseData[selectedKeyIndex].caseStageId : undefined;
        this.setState({
          selectedKeyIndex,
        });
        gotoNewTabCaseLandingPage(caseNumberUrl, this.state.queueId);
        break;
      default:
        break;
    }
  };

  onBookMarked(key, rowId) {
    const rowData = rowId;//TODO: changed for AgGrid,  this.state.caseData[key].caseStageId for GDTable
    let presenceIndex = this.state.bookMarkedRows.findIndex(row => row === rowId);
    if (rowData) {
      if (presenceIndex === -1) {
        return postBookMarkCase(rowData)
          .then(() => {
            this.setState((prevState) => ({
              bookMarkedRows: prevState.bookMarkedRows.concat(rowId),
            }));
          })
          .catch((error) => {

            console.log('Error Occured while Bookmarking the case', error);
          });
      }
      else {
        return undoBookMarkCase(rowData)
          .then(() => {
            this.setState((prevState) => ({
              bookMarkedRows: prevState.bookMarkedRows.filter(row => row !== rowId),
            }));
          })
          .catch((error) => {
            console.log('Error Occured while un-bookmarking the case', error);
          });

      }
    }
  };

  gotoCaseLandingPage(selectedKeyIndex) {
    sessionStorage.setItem('op1CaseDetail', JSON.stringify(this.state.caseData[this.state.selectedKeyIndex]));
    let caseNumberUrl = this.state.caseData[selectedKeyIndex].caseNumber ? '/caselanding/' + this.state.caseData[selectedKeyIndex].caseNumber : this.state.caseData[selectedKeyIndex].caseStageId ? '/caselanding/casestage/' + this.state.caseData[selectedKeyIndex].caseStageId : undefined;
    this.props.history.push({
      state: {
        queueId: this.state.queueId, 
        data: this.state.caseData[selectedKeyIndex],
        prevPath: `${this.props.location.pathname}${this.props.location.search}`,
      },
      pathname: `${caseNumberUrl}`,
    });
  };

  gotoCaseSelectionPage(selectedKeyIndex, newValues) {
    VITE_IMAGE_MATCH_QUEUES.indexOf(this.state.queueId) === -1 ?

      this.props.history.push({
        pathname: this.props.location.pathname + `/caseselection/${this.state.caseData[selectedKeyIndex].caseNumber}`,
        state: { prevPath: this.props.location.pathname, reloadQueueLandingPage: this.reloadQueueLandingPage, deleteCase: this.deleteCase },
      },
      )
      :
      this.props.history.push({
        pathname: this.props.location.pathname + '/imageselection',
        state: {
          queueId: this.state.queueId,
          caseSelectionConfig: this.state.structureMetaData.caseSelectionConfig,
          imageSelectionConfig: this.state.structureMetaData.imageSelectionConfig,
          data: this.state.caseData[selectedKeyIndex],
          prePopulatedFilterValues: newValues,
          openBanner: this.setBannerOpen,
          prevPath: this.props.location.pathname,
          setNotification: this.props.setNotification,
          caseNumber: this.state.caseData[selectedKeyIndex].caseNumber,
        },
      },
      )
  };

  // eslint-disable-next-line no-undef
  toggleFileExport = () => {
    this.setState({ filterExportIsVisible: !this.state.filterExportIsVisible });
  };

  closeBanner() {
    this.setState({
      isLoading: false,
    });
    this.props.closeNotification();
  };

  closeSaveFilterFailBanner() {
    this.setState({
      saveFilterFail: false,
    });
  };

  closeFilterBanner() {
    this.setState({
      isRequiredFilter: false,
    });
  };

  copyToClipBoard(value) {
    const dummy = document.createElement('textarea');
    document.body.appendChild(dummy);
    dummy.value = value;
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);
    this.setState({
      targetDone: true,
    });
  };
  /**
   * Reset targetDone value to reset notification displayed
   */
  closeNotification() {
    this.setState({
      targetDone: false,
      isLoading: false,
    });
    this.props.setAccountNumberId(true);
    this.props.closeNotification();
  };

  reloadQueueLandingPage() {
    this.getAllCasesData(this.state.queueId, this.state.lazyLoadPageNumber, this.state.recordsShown, this.state.gridSortArray, true, this.state.appliedFilterParams);
    this.props.closeNotification();
  };

  reloadPage() {
    this.props.closeNotification();
    window.location.reload();
  };

  setPrimaryButtonAction() {
    if (this.props.banner.refreshData === "true") {
      this.setState({ isLoading: true })
    } else if (this.props.banner.refreshData === "false") {
      this.setState({ isLoading: false })
    }
    if (!this.props.banner.primaryButtonAction) {
      this.copyToClipBoard(this.props.banner.primaryButtonActionValue);
    } else {
      this.props.banner.primaryButtonAction(this.props.banner.primaryButtonActionValue);
    }
  };
  /**
   * This method is responsible to show notification for manual transaction add
   */
  renderResponseBanner() {
    return (
      <div>
        <ImagePortal>
        <ResponseBanner
          titleStyle={{ color: 'light-green' }}
          descriptionStyle={{ color: 'grey' }}
          valueStyle={{ color: 'black' }}
          title={this.props.banner.title}
          description={this.props.banner.description}
          type={this.props.banner.type}
          onClose={this.closeNotification}
          cancel
          secondaryButtonText={this.props.banner.secondaryButtonText}
          primaryButtonText={this.props.banner.primaryButtonText}
          cancelButtonText={this.props.banner.cancelButtonText}
          isSecondaryButton
          isSecondaryButtonActive={this.state.targetDone}
          secondaryButtonAction={this.closeNotification}
          primaryButtonAction={this.setPrimaryButtonAction}
          primaryButtonActionValue={this.props.banner.primaryButtonActionValue}
          cancelOnly={this.props.banner.cancelOnly}
          textField={this.props.banner.textField}
          descriptionHtml={this.props.banner.descriptionHtml}
        />
        </ImagePortal>
      </div>
    );
  };

  // eslint-disable-next-line no-undef
  toggleDrawer = () => {
    document.body.style.overflow = 'visible';
    this.props.setDrawerOpenFlag(false);
    this.setState({
      drawerOpen: !this.state.drawerOpen,
    });
  };

  // eslint-disable-next-line no-undef
  getNextRow = () => {
    const { sequenceKey } = this.state;
    const { tableData } = this.state.caseData;
    // get currentIndex
    const currentIndex = tableData.findIndex(
      (item) => item.seq_key === sequenceKey,
    );
    // get nextIndex
    let nextIndex = currentIndex + 1;
    // if nextIndex equals tableData.length, then set nextIndex to 0
    if (nextIndex === tableData.length) {
      nextIndex = 0;
    }
    // get row from tableData given nextIndex
    return tableData[nextIndex];
  };

  // eslint-disable-next-line no-undef
  goToNextRecord = () => {
    this.state.selectedKeyIndex + 1 < this.state.caseData.length && this.setState((prevState) => ({
      selectedKeyIndex: prevState.selectedKeyIndex + 1,
    }));
  };

  // eslint-disable-next-line no-undef
  goToPreviousRecord = () => {
    this.state.selectedKeyIndex > 0 && this.setState((prevState) => ({
      selectedKeyIndex: prevState.selectedKeyIndex - 1,
    }));
  };

  prepopulateFilterValues(selectedKeyIndex) {
    const rowData = this.state.caseData[selectedKeyIndex];
    const structure = [].concat(this.state.structureMetaData);
    const filterList = this.state.structureMetaData.caseSelectionConfig.searchFilters;
    let newValue;
    const newValues = [];
    filterList.map((filter) => {
      let data;
      structure.map((row) => {
        row.dataColumns?.forEach((item) => {
          if (filter.columnKey === item.columnKey) {
            data = rowData[`${item.columnKey}`];
            newValue = Object.assign({}, {
              [filter.reportFilterId]: { v1: data },
            });
            newValues.push(newValue);
          } else {
            newValue = Object.assign({}, {
              [filter.reportFilterId]: { v1: '' },
            });
          }
        },
        );
      });
    });
    this.setState({ prePopulatedFilterValues: newValues });
    if ((this.props.location.pathname).indexOf('/caseselection') == -1 || (this.props.location.pathname).indexOf('/imageselection') == -1) {
      this.state.caseData[selectedKeyIndex] && setCaseStageId(this.state.caseData[selectedKeyIndex].caseStageId);
      this.gotoCaseSelectionPage(selectedKeyIndex, newValues);
    }
  }

  deactivateFilter(id) {
    const newFilters = this.state.activeFilters.filter((filter) => {
      return filter.id !== id;
    });

    this.setState(
      {
        activeFilters: mapActiveFilters(newFilters, this.state.filters),
        savedFilters: mapSavedFilters(this.state.savedFilters, newFilters),
      },
      () => {
        const currentValuesObj = this.state.activeFilters.reduce(
          (obj, value) => {
            return Object.assign(obj, {
              [value.id]: {
                v1: value.v1,
                v2: value.v2,
                // type: value.type,
              },
            });
          },
          {},
        );

        this.applyFilters(currentValuesObj);
      },
    );
  };

  toggleDropdown(event) {
    event.persist();
    const id = event.currentTarget.id;
    const dropdownToggled = this.state.dropdownToggled;
    dropdownToggled[`${id}`] = !dropdownToggled[`${id}`];
    this.setState({ dropdownToggled });
  };

  onChange(event) {
    if (event.target) {
      this.setState({ [event.target.name]: event.target.value });
    }
  };

  removeSavedFilter(id) {
    const newFilters = this.state.savedFilters.filter((filter) => {
      return filter.id !== id;
    });
    this.props.deleteSavedFilters(id, this.props.searchTypeId);

    this.setState(
      {
        savedFilters: newFilters,
        isOpenSavedFilterDropdown: false,
      },
      () => {
        const body = document.querySelector('body');
        const e = document.createEvent('MouseEvents');
        e.initEvent('mousedown', true, true);
        body.dispatchEvent(e);
      },
    );
  };

  selectQueue(queueId, regionCode, queueName,acquirerAccessCode) {
    this.setState({
      isLoading: true,
    })
    if (VITE_AVAILABLE_QUEUES.indexOf(queueId) !== -1) {
      this.props.fetchDataColumns(getMetaData(queueId).pageId);
      this.setState({
        gridSortArray: getMetaData(queueId).defaultSort,
      })
      this.props.history.push({
        pathname: `/queue/${queueId}`,
        search: regionCode === null ? '' : `?regionCode=${regionCode}`,
      });
    }
    if (VITE_QUEUE_MGMT_QUEUES.indexOf(queueId) !== -1) {
      this.props.history.push({
        pathname: '/queue-management-landing',
        search: `?queueid=${queueId}&region=${regionCode}&acquirerAccessCode=${acquirerAccessCode}`,
      });
    }
  };

  applyFilters(newValues, filterList) {
    // generate request as per the API
    const newFilterValues = Object.keys(newValues).map((key) => {
      const metaData = filterList.find((filter) => {
        return filter.elementId === key;
      });
      if(metaData != undefined){
        return Object.assign({}, newValues[key], { id: key, elementCategoryName: metaData.elementCategoryName, elementTypeName: metaData.elementTypeName });
      }
    });
    let filterParams = [];
    newFilterValues && newFilterValues.forEach((filterElement) => {
     if(filterElement != undefined){
      if (filterElement.elementTypeName === 'DATE' || filterElement.elementTypeName === 'CURRENCYRANGE') {
        const fromToKeys = filterElement.id.split('-');

        filterParams = filterParams.concat({
          elementId: fromToKeys[0],
          elementValue: filterElement.elementTypeName === 'DATE' && filterElement.type !== 'STARTS_WITH' ? this.changeDateFormat(filterElement.v1) : filterElement.v1,
        });

        if (undefined !== filterElement.v2 && '' !== filterElement.v2) {
          filterParams = filterParams.concat({
            elementId: fromToKeys[1],
            elementValue: filterElement.elementTypeName === 'DATE' ? this.changeDateFormat(filterElement.v2) : filterElement.v2,
          });
        }
      } else if (filterElement.elementTypeName === 'CC_NUMBER') {
        if (filterElement.v2 !== undefined) {
          filterParams = filterParams.concat({
            elementId: 'lastFourMasked',
            elementValue: filterElement.v2,
          })
        } if (filterElement.v1 !== undefined) {
          filterParams = filterParams.concat({
            elementId: 'firstSixMasked',
            elementValue: filterElement.v1,
          });
        }
      } else {
        filterParams = filterParams.concat({
          elementId: filterElement.id,
          elementValue: filterElement.v1,
        });
      }
    }
    });


    const newActiveFilters = this.mapActiveFilters(
      newFilterValues,
      this.state.finalFilterElements,
    );
    if (newActiveFilters.length === 0) {
      this.setState({
        isRequiredFilter: true,
        isVisible: true,
      });
    } else {
      const filters = [];
      newActiveFilters.forEach((newActiveFilter) => {
        const filter = {
          fieldId: newActiveFilter.id,
          fieldValues1: this.setFieldValue(newActiveFilter),
          fieldvalue2: (newActiveFilter.v2 && newActiveFilter.name.includes('Date')) ? this.changeDateFormat(newActiveFilter.v2) : newActiveFilter.v2,
        };


        if (newActiveFilter.v1 !== undefined && newActiveFilter.v1.length != 0) { filters.push(filter); }
        if (newActiveFilter.id == 'firstSixMasked-lastFourMasked' && newActiveFilter.v1 == undefined) {
          filter.fieldValues1 = [""];
          filters.push(filter);
        }
      });
      if (filters.length !== 0) {
        this.setState({
          isVisible: false,
          activeFilters: newActiveFilters,
          isLoading: true,
          isRequiredFilter: false,
        });
        let accountNumberFilter = filterParams.find(data => data.elementId == 'trans_account_number');
        if (accountNumberFilter) {
          this.getTokenFromCardNumber(accountNumberFilter.elementValue, filterParams);
        }
        else {
          this.getAllCasesData(this.state.queueId, 0, 25, getMetaData(this.state.queueId).defaultSort, false, filterParams);
        }

      } else {
        this.setState({
          isRequiredFilter: true,
          isVisible: true,
        });
      }
    }
    scroll(0, 0);
  };

  getTokenFromCardNumber(cardNumber, filters) {
    return getToken(cardNumber)
      .then((apiResponse) => {
        if (apiResponse.status.statusCode === 2000) {
          const updatedFilters = filters.map(function (obj) {
            if (obj.elementId == 'trans_account_number')
              return { ...obj, elementValue: apiResponse.data.GlobalToken.split("/") };
            return { ...obj };
          });
          this.getAllCasesData(this.state.queueId, 0, 25, getMetaData(this.state.queueId).defaultSort, false, updatedFilters);
        }
      })
      .catch((error) => {
        this.setState({ caseDataErr: true, isLoading: false });
        console.log('Error Occured while tokenizing Card Number', error);
      });

  };

  setFieldValue(newActiveFilter) {
    if (newActiveFilter.name.includes('Date') && newActiveFilter.v1.split('/').length > 1) { return this.changeDateFormat(newActiveFilter.v1).split(); }
    return newActiveFilter.v1 !== undefined && !isObject(newActiveFilter.v1) ? newActiveFilter.v1.split() : newActiveFilter.v1;
  };

  changeDateFormat(field) {
    switch (field) {
      case '':
      case 'yesterday':
      case 'last_seven_days':
      case 'last_month':
      case 'this_month':
      case 'this_year': return field;
      default:
        const dateFormat = 'YYYY-MM-DD';
        return moment(field).format(dateFormat);
    }
  };

  closeFilterPane = () => {
    scroll(0, 0);
    this.setState({ isVisible: false });
  };

  toggleFilterPane() {
    document.body.classList.add('instant-header');
    scroll(0, 0);
    if (this.props.filters.length === 0 && !this.state.isVisible) {
      this.props.fetchFilterElements(this.props.searchTypeId);
      this.props.fetchSavedFilterElements(this.props.searchTypeId);
    }
    this.setState(
      {
        isVisible: !this.state.isVisible,
      },
    );
  };

  mapActiveFilters(filters = [], data = []) {
    const results = [];
    filters.forEach((filter) => {
      if(filter != undefined) {      
      const matchingFilter = data.find((column) => (column.elementId) === (filter.id));
      if (matchingFilter &&
        matchingFilter.elementLabel) {
        results.push(
          Object.assign({}, filter, {
            name: matchingFilter.elementLabel,
            value: !filter.v2 ? filter.v1 : null,
            values: filter.v2 ? { v1: filter.v1, v2: filter.v2 } : null,
            v1: filter.v1,
            v2: filter.v2,
            category: matchingFilter.elementCategoryName,
            elementType: matchingFilter.elementTypeName,
          }),
        );
      } 
    }
    });
    return results;
  };

  toggleSavedFilter = () => {
    this.setState({ saveFilterToggled: !this.state.saveFilterToggled });
  };

  saveFilterName = () => {
    let elements = [];
    this.state.activeFilters.forEach((activeFilter) => {
      if (activeFilter.category === 'FROM-TO') {
        const idArr = activeFilter.id.split('-');
        elements = elements.concat(this.createSaveFilterElement(idArr[0], activeFilter.v1));
        if (activeFilter.v2 !== undefined) {
          elements = elements.concat(this.createSaveFilterElement(idArr[1], activeFilter.v2));
        } else {
          elements = elements.concat(this.createSaveFilterElement(idArr[1], ''));
        }
      } else if (activeFilter.elementType == 'MULTISELECT') {
        activeFilter.v1.forEach((value) => {
          elements = elements.concat(this.createSaveFilterElement(activeFilter.id, value));
        });
      } else if (activeFilter.elementType === 'CC_NUMBER') {
        elements = elements.concat(this.createSaveFilterElement('firstSixMasked', activeFilter.v1));
        elements = elements.concat(this.createSaveFilterElement('lastFourMasked', activeFilter.v2));
      } else {
        elements = elements.concat(this.createSaveFilterElement(activeFilter.id, activeFilter.v1));
      }
    });
    const updateIndex = this.state.savedFilters.findIndex((caseObject) => {
      return caseObject.filterName === this.state.filterName;
    });
    if (updateIndex == -1) {
      this.props.saveActiveFilters(this.props.searchTypeId, elements, this.state.filterName);
      this.setState({ filterName: '', saveFilterToggled: false });
    } else {
      this.setState({
        saveFilterFail: true,
        filterName: '',
      });
    }
  };

  createSaveFilterElement(id, value) {
    const element = {};
    element.elementId = id;
    element.elementValue = value;
    return element;
  };

  updateSearchField(value) {
    const lowercaseSearchTerm =
      value && value.toLowerCase && value.toLowerCase();
    const filteredFilters = this.props.savedFilters.filter((filter) => {
      // the most redundant, yet appropriate name ever
      const lowercaseFilterName = filter.filterName.toLowerCase();
      return lowercaseFilterName.includes(lowercaseSearchTerm);
    });
    this.setState({
      currentSearchTerm: value,
      savedFilters: this.mergeSavedElementIdsForRangeElements(filteredFilters),
    });
  };

  setSavedFilterAsActive(id) {
    let index = -1;
    const newFilters = this.state.savedFilters.map((filter) => {
      index++;
      return Object.assign({}, filter, {
        isActive: filter.filterId === id,
      });
    });
    this.setState(
      {
        savedFilters: newFilters,
        isOpenSavedFilterDropdown: false,
      },
      () => {
        const filterSetToUse = this.state.savedFilters.find(
          (set) => set.isActive,
        );
        this.applySavedFilterSet(filterSetToUse);
      },
    );
  };

  applySavedFilterSet(filterSetToUse) {
    const newActiveFiltersStr = filterSetToUse.filterParams;
    const newActiveFilters = this.mapActiveFilters(newActiveFiltersStr, this.state.finalFilterElements);
    this.setState({
      activeFilters: newActiveFilters,
    }, () => {
      // this.props.applySavedFilterSet(newActiveFilters);
      const body = document.querySelector('body');
      const e = document.createEvent('MouseEvents');
      e.initEvent('mousedown', true, true);
      body.dispatchEvent(e);
    });
    this.setState(
      {
        isVisible: true,
      },
    );
  };

  clearAllFilters() {
    
    this.setState(
      {
        activeFilters: [],
        savedFilters: mapSavedFilters(this.state.savedFilters),
      },
      () => {
        const currentValuesObj = this.state.activeFilters.reduce(
          (obj, value) => {
            return Object.assign(obj, {
              [value.id]: {
                v1: value.v1,
                v2: value.v2,
                type: value.type,
              },
            });
          },
          {},
        );
        const clearAllFlag = true;
      },
    );
   
    this.refreshTimeFeed();
  };

  refreshTimeFeed()
  {
    let acquirerList=getAcquirerAccessList();
    this.setState({
        dataColumns: this.addIconsToGDTableHeadersList(this.state.dataColumns),
        caseData: [],
        isLoading:true,
        totalRecords: this.state.totalRecords,

      },() => {this.getDataForAllUnmatchedCases(this.state.queueId, 0, 25, this.state.gridSortArray,this.props.appliedFilterParams,this.props.regionCode,acquirerList,false);
      });
  };

  getDataForAllUnmatchedCases(queueId, pageNumber, size, sortArray, appliedFilterParams, regionCode, acquirerList,lazyLoad){
    lazyLoad=false;
    const structureMetaData = getMetaData(queueId);
    structureMetaData.dataColumns = [...this.state.dataColumns];
    if(queueId == QUEUE_IDS.ACTIVE_STAGE){
      regionCode = this.state.regionCode;
    }
    return getAllUnmatchedCases(queueId, pageNumber, size, sortArray, appliedFilterParams, regionCode, acquirerList)
      .then((apiResponse) => {
         const formattedData = this.getFormattedData(queueId, apiResponse);
        this.setState((prevState) => ({
          structureMetaData,
          caseData:  lazyLoad ? prevState.data.concat(formattedData) : formattedData,
          totalRecords: apiResponse.data.totalElements,
          totalPages: apiResponse.data.totalPages,
          currentPage: apiResponse.data.number + 1,
          recordsShown: size,
          isNextPage: !apiResponse.data.last,
          gridSortArray: sortArray,
          caseDataErr: false,
          isLoading: false,
          bookMarkedRows: [],
          isTableVisible: true,
          appliedFilterParams: appliedFilterParams,
          agLoader: false,

        }));
        scroll(0,0);
    
      }).catch((error) => {
        this.setDataError();
        this.setState({
          isLoading: false,
          isSortClicked: false,
        })
        console.log('Error Occured while fetching unmatched case details', error);
      });
  };

  setAggridCaseData = (data, pageNum, sortArray) => {
    this.setState((prevState) => ({
      caseData: (this.state.isFirstCall || pageNum == 1) ? data : prevState.caseData.concat(data),
      isFirstCall: false,
      gridSortArray: sortArray,
    }))
  };

  setDataError = () => {
    this.setState({
      caseDataErr: true,
    })
  };

  serverSideData = (props, thisObject) => {
    return {
      getRows(params) {
        document.addEventListener('click', (e) => {
          document.isControl = !!e.ctrlKey;
        });
        let acquirerAccessList= getAcquirerAccessList();
        const newSortArray = params?.api?.getColumnState()
          ?.filter(ele => ele?.sort)
          ?.map(({ colId, sort }) => ({ key:colId, order: sort === 'asc' ? 1 : 0 }));
        const totalRecords = thisObject.state?.totalRecords || 0;
        if (!thisObject.state.isSortClicked) {
          const updatedPageNumber = thisObject.state.isColumnChanged ? 0 : thisObject.state.pageNumber;
          return getAllUnmatchedCases(props.queueId, updatedPageNumber, 25, newSortArray, props.appliedFilterParams, props.regionCode, acquirerAccessList)
            .then((apiResponse) => {
              let count = apiResponse.data.pageable.offset + apiResponse.data.numberOfElements;
              props.setRecordCount(count, apiResponse.data.totalElements);
              const formattedData = props.getFormattedData(props.queueId, apiResponse);
              const pageNum = updatedPageNumber + 1;
              props.setAggridCaseData(formattedData, pageNum, newSortArray);
              flushSync(()=> {
                thisObject.setState({
                  pageNumber: pageNum,
                  isLoading: false,
                  isSortClicked: false,
                  acquirerAccessList: acquirerAccessList,
                  isColumnChanged: false,
                })
              });
              const isLastPage = apiResponse?.data?.last;
              const rowCount = isLastPage ? (apiResponse.data.pageable.offset + formattedData.length) : undefined;
              params.success({
                rowData: formattedData,
                rowCount: rowCount,
              });
              setTimeout(() => {
                thisObject.autoSizeAllColumns(params?.api?.getColumnDefs());
              }, 100);
            })
            .catch((error) => {
              props.setDataError();
              flushSync(()=> {
                thisObject.setState({
                  isSortClicked: false,
                  isColumnChanged: false,
                })
              });
              params.fail();
              console.log('Error Occured while fetching unmatched case details', error);
            });
        } else {
          params.success({
            rowData: [],
            rowCount: totalRecords,
          });
        }
      }
    }
  };

  render() {
    const filterPaneTriggerClasses = classnames('filter-pane-trigger', {
      'is-disabled': false,
    });
    let report = Object.assign({}, this.state.structureMetaData);
    report.dataColumns = Object.assign([], this.state.dataColumns);
    const hasSummaryRow = summaryData.length > 0;
    const isIE = VITE_isIE !== undefined;
    const mainContentClass = isIE ? 'case-landing-ie' : 'case-landing';
    let cases = [];
    let totalCases = this.state.exceptionCases && this.state.merchMatchCases && this.state.schemeCases &&
      cases.concat([...this.state.exceptionCases, ...this.state.merchMatchCases, ...this.state.schemeCases]);
    let acquirerAccessList=getAcquirerAccessList();
    if(acquirerAccessList.includes('GPN')) {
      totalCases = totalCases && this.state.assignedCases&& this.state.defaultCases && this.state.merchImageCases &&
      cases.concat([...totalCases, ...this.state.assignedCases, ...this.state.defaultCases, ...this.state.merchImageCases]);
    }
    if(acquirerAccessList.includes('HPY')) { 
      totalCases = totalCases && this.state.wexCases && 
      cases.concat([...totalCases, ...this.state.wexCases]);
    }
    if(acquirerAccessList.includes('GPN') || acquirerAccessList.includes('HPY')) {
      totalCases = totalCases && this.state.amexCases && 
      cases.concat([...totalCases, ...this.state.amexCases]);
    }
    if(acquirerAccessList.includes('MXP')) { 
      totalCases = totalCases &&  this.state.mexicoCases &&
      cases.concat([...totalCases, ...this.state.mexicoCases]);
    }
    const queueListData = totalCases && totalCases.sort(sort_by('queueName', false, function (a) { return a.toUpperCase() }));
    const tableName = totalCases && this.getQueueList(this.state.regionCode, this.state.queueId, totalCases);
    const pageId = this.state.queueId && getMetaData(this.state.queueId).pageId;
    let acquirerList = getAcquirerAccessList();
    if (this.props.user !== undefined && (this.props.user.parsedPermissions.queue.viewCasesInQueue 
      || this.state.hideBaseQueueDropdown)) {
      return (
        <section
          className={mainContentClass}
        >
          {this.state.setSize == true && this.checkSize()}
          {this.props.notification.transShow && this.renderResponseBanner()}
          <div className={this.props.isSearchActive ? 'main-content--header reports-container--header secondary-header' : 'main-content--header reports-container--header'} style={{ zIndex: 3 }}>
            <div className="flex-left">
              <h1>Queues</h1>
              {!this.state.hideBaseQueueDropdown && <div className="dropdown-list">
                <QueuesDropdown
                  queueList={queueListData}
                  currentQueue={tableName}
                  selectQueue={this.selectQueue}
                />
              </div>}
            </div>
            {this.props.user !== undefined && this.props.user.parsedPermissions.case.masterPermission &&
              (this.props.queueId == QUEUE_IDS.TRANS_UNMATCH_QUEUE_ID || this.props.queueId == QUEUE_IDS.AMEX_QUEUE_ID || this.props.queueId == QUEUE_IDS.WEX_QUEUE_ID || this.props.queueId == QUEUE_IDS.ACTIVE_STAGE) && <div className="flex-right" style={{ paddingRight: 13 }}>
                <div className="gd-report-runner__actions">
                  <div className="gd-report-runner__actions-filters">
                    <a data-tip data-for="filtering" data-offset="{'right': 320}">
                      <GDActiveFiltersDropdown
                        activeFilters={this.state.activeFilters}
                        dateFormat={this.state.dateFormat}
                        deactivateFilter={this.deactivateFilter}
                        dropdownToggled={this.state.dropdownToggled}
                        filterDefinitions={this.state.finalFilterElements}
                        toggleDropdown={this.toggleDropdown}
                        translations={getTranslations()}
                      />
                    </a>
                  </div>
                  {this.state.activeFilters.length > 0 && (
                    <div className="gd-report-runner__actions-clear">
                      <LinkInlineButton action={this.clearAllFilters}>
                        Clear All
                      </LinkInlineButton>
                      <span>&nbsp;|&nbsp;</span>
                    </div>
                  )}
                  <div className="gd-report-runner__actions-save">
                    <LinkInlineButton
                      action={this.toggleSavedFilter}
                      disabled={this.props.isProvidingSupport}
                    >
                      Save
                    </LinkInlineButton>
                    {this.state.saveFilterToggled &&
                      <GDNewFilterDropdown
                        toggleDropdown={this.toggleSavedFilter}
                        onChange={this.onChange}
                        saveFilterName={this.saveFilterName}
                        translations={getTranslations()}
                        value={this.state.filterName}
                      />
                    }
                  </div>
                </div>
                <div className="gd-filters-dropdown__wrapper gd-report-runner__icon-popup-wrapper">
                  <OptionBoxPopup
                    icon={StarIcon}
                    id="Transaction Search_OptionBoxPopup"
                    triggerText=""
                    showHelpText={getTranslations().savedFilters}
                  >
                    <GDSavedFiltersDropdown
                      noSavedFilters={this.state.noSavedFilters}
                      onChange={this.updateSearchField}
                      removeSavedFilter={this.removeSavedFilter}
                      savedFilters={this.state.savedFilters}
                      searchTerm={this.state.currentSearchTerm}
                      setSavedFilterAsActive={this.setSavedFilterAsActive}
                      translations={getTranslations()}
                    />
                  </OptionBoxPopup>
                </div>
                <div
                  role="button"
                  tabIndex={0}
                  id="Settled Batches_filter_btn"
                  className={filterPaneTriggerClasses}
                  onClick={this.toggleFilterPane}
                  aria-expanded={this.state.isVisible}
                >
                  <span className="gd-report-runner__filter-toggle">Filter</span>
                </div>
              </div>}
          </div>
          {
            this.state.isVisible && this.state.finalFilterElements.length == 0 && <BVLoader20 />
          }
          <div className={this.state.isVisible && this.props.isSearchActive ? '' : 'main-content--wrapper'}>

            {this.state.isVisible && this.state.finalFilterElements.length > 0 && (
              <div className={this.props.isSearchActive ? '' : 'gd-filter-pane__wrapper'}>
                <FilterPane
                  applyFilters={this.applyFilters}
                  closeFilterPane={this.closeFilterPane}
                  currentValues={this.state.activeFilters}
                  dateFormat="MM/DD/YYYY"
                  filterList={this.state.finalFilterElements}
                  isVisible={this.state.isVisible}
                  translations={getTranslations()}
                  reportName="Received Disputes_filterPane"
                  extraClass="some-class"
                  resetScrollPos={this.resetScrollPos}
                  clearAllFilters={this.clearAllFilters}
                />
              </div>
            )}
            {this.state.saveFilterFail && <div>
              <ImagePortal>
              <ResponseBanner
                titleStyle={{ color: 'light-green' }}
                descriptionStyle={{ color: 'grey' }}
                valueStyle={{ color: 'black' }}
                title="Error Occured"
                description="Filter name already present.Please enter unique filter name"
                type="danger"
                onClose={this.closeSaveFilterFailBanner}
                cancelButtonText="DISMISS"
                primaryButtonActionValue=""
                primaryButtonText="OKAY, DO SOMETHING TO FIX IT"
                primaryButtonAction={this.closeSaveFilterFailBanner}
              />
              </ImagePortal>
            </div>}
            {(pageId === 'tran_unmatched' || pageId === 'active_stage' || pageId === 'amex_queue') && this.state.isRequiredFilter &&
              <ImagePortal>
              <ResponseBanner
                titleStyle={{ color: 'light-green' }}
                descriptionStyle={{ color: 'grey' }}
                valueStyle={{ color: 'black' }}
                title="Validation Error"
                description="Atleast one field is required for search"
                type="danger"
                onClose={this.closeFilterBanner}
                cancelButtonText="DISMISS"
                primaryButtonActionValue=""
                primaryButtonText="OKAY, DO SOMETHING TO FIX IT"
                primaryButtonAction={this.closeFilterBanner}
              />
              </ImagePortal>
            }

            {(this.state.isLoading || totalCases === undefined) && <BVLoader20 />}
            {!this.state.selectionPanelOpen && !this.state.isLoading && totalCases && !this.state.caseDataErr && this.state.dataColumns && this.state?.dataColumns?.length > 0 && <div className="queue-landing-content" ref={((ref) => (this.gdTable = ref))}>
              <GDTable
                setAggridCaseData={this.setAggridCaseData}
                serverSideData={this.serverSideData}
                className={this.state.drawerOpen ? ' opacity' : ''}
                tableName={this.state.regionCode == "HPY" && ( tableName && !tableName.includes("HPS") && (this.props.queueId != QUEUE_IDS.ACTIVE_STAGE)) ? "HPS " + tableName : (!acquirerList.includes('GPN') && !tableName.includes(this.state.regionCode)) ? this.state.regionCode + " " + tableName : tableName}
                report={report}
                data={this.state.caseData}
                dateFormat="MM/DD/YYYY"
                totalPages={this.state.totalPages}
                totalRecords={this.state.totalRecords}
                recordsCountText={{ showingRecords: 'Showing records', preposition: 'of' }}
                currentPage={this.state.currentPage}
                recordsShown={this.state.recordsShown}
                hasSummaryRow={hasSummaryRow}
                summaryData={summaryData}
                sort={this.state.gridSortArray}
                handleSort={this.handleSort}
                pageHandler={this.pageHandler}
                translations={getTranslations()}
                filterText={this.state.filterText}
                onRowClick={this.onRowClick}
                onSearchChange={this.onSearchChange}
                isNextPage={this.state.isNextPage}
                exporting={this.state.exporting}
                exportAction={this.exportAction}
                filterExportIsVisible={this.state.filterExportIsVisible}
                toggleFileExport={this.toggleFileExport}
                actionButtonText="Actions"
                rowActionClick={this.rowActionClick}
                isPagable={this.state.isPagable}
                loadDataOnScroll={this.loadDataOnScroll}
                openBoxDropDownStyle={{
                  width: 150,
                  marginLeft: -52,
                  fontSize: 'initial',
                }}
                isLoading={this.state.isLoadingComplete}
                saveCurrentlyVisibleColumns={this.saveCurrentlyVisibleColumns}
                addIconsToGDTableHeadersList={this.addIconsToGDTableHeadersList}
                bookMarkedRows={this.state.bookMarkedRows}
                onBookMarked={this.onBookMarked}
                queueId={this.state.queueId}
                appliedFilterParams={this.state.appliedFilterParams}
                lazyLoadPageNumber={this.state.lazyLoadPageNumber + 1}
                agLoader={this.state.agLoader}
                pageName='queueLanding'
                setRecordCount={this.setRecordCount}
                isAgGrid={true}
                getFormattedData={this.getFormattedData}
                setDataError={this.setDataError}
                regionCode={this.state.regionCode}
                exportFileName={tableName}
                archiveUnmatchedSchemeImage={this.archiveUnmatchedSchemeImage}
              />
            </div>
            }
            {this.state.caseDataErr && !this.state.loading && (
              <EmptyState
                translations={{ emptyStateHeading: 'This queue is empty.', emptyStateDescription: 'Please try again later.' }}
              />
            )}
            {this.state.drawerOpen && <div className="drawer open">
              <GDDetailView
                type="report"
                data={this.state.caseData[this.state.selectedKeyIndex]}
                goBack={this.toggleDrawer}
                goToPreviousRecord={this.goToPreviousRecord}
                goToNextRecord={this.goToNextRecord}
                structure={[].concat(this.state.structureMetaData)}
                preferences={{}}
                recordCountSize={this.state.caseData.length}
                selectedKeyIndex={this.state.selectedKeyIndex}
              /> 
            </div>
            }
          </div>
        </section>
      );
    }
    else {
      return (
        <EmptyState
          translations={{ emptyStateHeading: this.state.emptyStateHeading, emptyStateDescription: this.state.emptyStateDescription }}
        />
      );
    }
  };
}

QueueLanding.propTypes = {
  filters: PropTypes.array,
  savedFilters: PropTypes.array,
};

QueueLanding.defaultProps = {
  filters: [],
  savedFilters: [],
};

const mapStateToProps = (state) => ({
  banner: state.notification.banner[0],
  notification: state.notification,
  filters: state.searchFilter.filters,
  savedFilters: state.savedFilter.filters,
  searchTypeId: state.searchFilter.searchTypeId,
  dataColumns: state.dataColumns?.columns,
  isSearchActive: state.appSearch.isSearchActive,
  pageId: state.dataColumns?.pageId,
  user: state.auth.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setNotification: (banner) => dispatch(addManualTransactionNotificationBanner(banner)),
    closeNotification: () => dispatch(closeNotificationBanner()),
    fetchFilterElements: (searchTypeId) => {
      dispatch(fetchFilterElements(searchTypeId));
    },
    fetchSavedFilterElements: (searchTypeId) => {
      dispatch(fetchSavedFilterElements(searchTypeId));
    },
    saveActiveFilters: (searchTypeId, activeFilters, filterName) => {
      dispatch(saveActiveFilters(searchTypeId, activeFilters, filterName));
    },
    deleteSavedFilters: (filterId, searchTypeId) => {
      dispatch(deleteSavedFilters(filterId, searchTypeId));
    },
    fetchSearchTypeIdBasedOnSearchName: (searchTypeId) => {
      dispatch(fetchSearchTypeIdBasedOnSearchName(searchTypeId));
    },
    setDrawerOpenFlag: (isDrawerActive) => {
      dispatch(setDrawerOpenFlag(isDrawerActive));
    },
    fetchDataColumns: (pageId) => {
      dispatch(fetchDataColumns(pageId));
    },
    setSearchOpenFlag: (isSearchActive) => {
      dispatch(setSearchOpenFlag(isSearchActive));
    },
    setAccountNumberId: (locked) => {
      dispatch(setAccountNumberId(locked));
    },
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(QueueLanding);
/* eslint-enable global-require, class-methods-use-this */
